import { SkillDTO } from "../../../../models/recruiting/candidate/skills/skill-dto";
import { SkillSTO } from "../../../../models/recruiting/candidate/skills/skill-sto";
import { BaseApiService } from "../../../base/base-api.service";

export class SkillsApiService extends BaseApiService<SkillDTO, SkillSTO> {
  constructor() {
    super({
      servicePath: "/Skills",
      loadItemsPath: "/GetSkills",
      saveItemsPath: "/SaveSkills",
    });
  }
}
